import { useEffect, useRef, useState } from "react";

type TouchDirection = "left" | "right" | null;

const useTouchScroll = () => {
	const [direction, setDirection] = useState<TouchDirection>(null);
	const touchStart = useRef(0);
	const SWIPE_THRESHOLD = 50; // minimum pixels to trigger a swipe

	useEffect(() => {
		const handleTouchStart = (e: TouchEvent) => {
			touchStart.current = e.targetTouches[0].clientX;
			setDirection(null);
		};

		const handleTouchMove = (e: TouchEvent) => {
			const touchEnd = e.targetTouches[0].clientX;
			const distance = Math.abs(touchStart.current - touchEnd);

			if (distance > SWIPE_THRESHOLD) {
				if (touchStart.current > touchEnd) {
					setDirection("left");
				} else {
					setDirection("right");
				}
			}
		};

		const resetDirection = () => {
			setDirection(null);
		};

		window.addEventListener("touchstart", handleTouchStart);
		window.addEventListener("touchmove", handleTouchMove);
		window.addEventListener("touchend", resetDirection);
		window.addEventListener("touchcancel", resetDirection);

		return () => {
			window.removeEventListener("touchstart", handleTouchStart);
			window.removeEventListener("touchmove", handleTouchMove);
			window.removeEventListener("touchend", resetDirection);
			window.removeEventListener("touchcancel", resetDirection);
		};
	}, []);

	return direction;
};

export default useTouchScroll;
